interface StampCardProps {
  purchases: number; // lifetime purchases at this shop; strip shows purchases % rewardsTarget
  pending: boolean; // a stamp request is in flight — same signal BrewStation's isWaiting gate uses
  rewardsTarget: number; // stamps EARNED per card (STAMPS_PER_CARD = 9) — the 10th slot is the free redemption, not a purchase
  offline?: boolean; // connectivity lost; strip is cached, wins over `pending`
  onOpenPass: () => void; // TAP → PASS tab, where the full PixelPass (grid + QR + wallets) lives
}

// Round 5 (Nik spec 2026-08-06): compact one-line pass strip. The grid it
// replaced lives only on PASS now — HOME's freed space goes to shop-owner
// content (ShopSpecials/ShopBeans, mounted by Dashboard right below this).
export default function StampCard({ purchases, pending, rewardsTarget, offline, onOpenPass }: StampCardProps) {
  const filledSlots = purchases % rewardsTarget;
  const cupsToFree = rewardsTarget - filledSlots;
  const statusPill = (label: string) => (
    <span className="pixel-corners-sm bg-background text-body-grey font-heading text-[8px] px-[9px] py-[5px]">
      {label}
    </span>
  );

  return (
    // 2px ink trim via an ink-filled wrapper - `pixel-corners` is a clip-path,
    // so a CSS border would be sliced off at every step.
    <div className="w-full pixel-corners bg-primary p-[2px]">
    <button
      type="button"
      aria-label="stamp card"
      onClick={onOpenPass}
      className="w-full bg-white pixel-corners px-[16px] py-[8px] flex items-center justify-between gap-3"
    >
      <span className="flex items-baseline gap-2.5 min-w-0">
        <span className="font-heading text-[8px] text-coral shrink-0">PIXEL PASS</span>
        <span className="font-grotesk font-bold text-[13px] text-primary truncate">{cupsToFree} till free</span>
      </span>
      {offline ? statusPill('CACHED') : pending ? statusPill('PENDING') : (
        <span className="font-heading text-[8px] text-body-grey shrink-0">{filledSlots} / {rewardsTarget}</span>
      )}
    </button>
    </div>
  );
}
